/* Alpacas Foods — scroll-reveal (IntersectionObserver). Porta lib/motion.ts.
   Marca seções/cards com data-reveal e seta data-in ao entrar na viewport.
   Respeita prefers-reduced-motion. */
(function () {
  'use strict';
  var SEL = [
    '.alp-section-head', '.alp-section-header', '.alp-cat-card', '.alp-recipe-card',
    '.alp-nutri-card', '.alp-value-card', '.alp-channel', '.alp-faq__item',
    '.alp-about__split', '.alp-plan', '.alp-cashback__step'
  ].join(',');

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.setAttribute('data-in', '');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  function scan() {
    document.documentElement.classList.add('js-reveal');
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.hasAttribute('data-reveal')) return;
      el.setAttribute('data-reveal', '');
      var siblings = el.parentElement ? Array.prototype.slice.call(el.parentElement.children) : [];
      var i = Math.max(0, siblings.indexOf(el));
      el.style.setProperty('--reveal-i', String(Math.min(i, 7)));
      io.observe(el);
    });
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  // Re-scan quando o Theme Editor recarrega seções.
  document.addEventListener('shopify:section:load', scan);
})();
